import { useConsolidateStoreOperations } from './useConsolidateStoreOperations';

export { useConsolidateStoreOperations };
